import { onMounted } from "vue";
import { templateRef } from "@vueuse/core";
import { useScrollTriggerAnimation } from "/composables/useScrollTriggerAnimation";


export default {
  __name: 'index',
  props: {
  initialLayout: {
    type: String,
    required: false,
    default: "left",
  },
  dataProvider: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const tpl_root = templateRef("tpl_root");
const tpl_title = templateRef("tpl_title");
const { reveal } = useScrollTriggerAnimation();

onMounted(() => {
  requestAnimationFrame(() => {
    if (props.dataProvider.title) {
      reveal(tpl_title.value, tpl_root.value.$el, "bottom", {
        intensity: "strong",
      });
    }

    reveal(
      tpl_root.value.$el.getElementsByClassName(
        "component-card-launcher-normal"
      ),
      tpl_root.value.$el,
      "alternate-x",
      {
        intensity: "strong",
        fade: false,
        duration: "long",
        stagger: "none",
      }
    );
  });
});

return { __sfc: true,props, tpl_root, tpl_title, reveal }
}

}